import { ErrorMessage } from '@hookform/error-message'
import { Checkbox, Flex, Typography, Form, Tooltip } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Controller } from 'react-hook-form'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import { InforCircle } from 'src/assets/icons'
import SelectWithSearch from './SelectWithSearch'
import './index.scss'

interface IProps {
  title: string
  checkboxTitle: string
  tooltipTitle: string
  placeholder: string
  options: any[]
  checkboxName: string
  selectName: string
  defaultSelectedValue: any[]
  defaultCheckboxValue: boolean
  control: any
  errors: any
  clearErrors: any
}

const SelectCpn = (props: IProps) => {
  const {
    title,
    checkboxTitle,
    tooltipTitle,
    placeholder,
    options,
    checkboxName,
    selectName,
    defaultSelectedValue,
    defaultCheckboxValue,
    control,
    errors,
    clearErrors,
  } = props

  return (
    <Flex vertical>
      <Form.Item label={title} className='isRequired label16' style={{ height: 0, margin: 0, flex: 1 }} />
      <Flex
        align='flex-start'
        justify='space-between'
        style={{ border: `1px solid ${colorBorderDisabled}`, padding: '20px', borderRadius: '16px', marginBottom: 24 }}
      >
        <Flex align='center' style={{ minWidth: 150, marginTop: 10 }}>
          <Controller
            name={checkboxName}
            control={control}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e: CheckboxChangeEvent) => {
                  if (e.target.checked) {
                    clearErrors(selectName)
                  }
                  field.onChange(e)
                }}
                disabled
                defaultChecked={defaultCheckboxValue}
              >
                {checkboxTitle}
              </Checkbox>
            )}
          />
          <Tooltip placement='bottom' title={tooltipTitle} style={{ padding: '8px 12px', color: 'red' }}>
            <InforCircle />
          </Tooltip>
        </Flex>
        <Flex vertical style={{ width: '90%' }}>
          <SelectWithSearch
            options={options}
            control={control}
            disabled
            name={selectName}
            placeholder={placeholder}
            defaultValue={defaultSelectedValue}
            clearErrors={clearErrors}
            errors={errors}
          />
          <Typography className='error-message'>
            <ErrorMessage errors={errors} name={selectName} />
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SelectCpn
